import {
    SET_USERSADMIN,
    SET_USERADMIN_LIST_TYPE_DOCUMENT,
    SET_USERADMIN_LIST_TYPE_ROL,
    SET_USER_ADMIN_ID,
    SET_USER_ADMIN_COMPANY_ID,
    SET_AFFILIATEDUSERS_LIST_GENDER,
    SET_STARASSIGNMENT_SEARCHAFFILIATES,
    SET_USERSTATUS
} from "@/views/users_admin/store/types/types.js";

const mutations = {
    [SET_USERSADMIN]: (state, payload) => state.userAdmin = payload,
    [SET_USERADMIN_LIST_TYPE_DOCUMENT ]: (state, payload) => state.typeUserAdmin = payload,
    [SET_USERADMIN_LIST_TYPE_ROL]: (state, payload) => state.typeUserAdminRol = payload,
    [SET_USER_ADMIN_ID]: (state, payload) => state.userAdminidDetails = payload,
    [SET_USER_ADMIN_COMPANY_ID]: (state, payload) =>state.userAdminidDetailsCompany = payload,
    [SET_AFFILIATEDUSERS_LIST_GENDER]: (state, payload) => state.genderAffiliated = payload,
    [SET_STARASSIGNMENT_SEARCHAFFILIATES]: (state, payload) => state.searchAffiliates = payload,
    [SET_USERSTATUS]: (state, payload) => state.userStatus = payload,
   
};

export default mutations